import { BRAND_COLORS } from "@/Utils/brandColors";
import { acknowledgeScanSubmitted } from "@/Utils/scanSubmittedMarker";
import { useLocation } from "react-router-dom";
import { useCustomNavigation } from "@/hooks/useCustomNavigation";

import "./avatarFailed.scss";

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const AvatarFailed = () => {
  const { navigateTo, navigateBack } = useCustomNavigation();
  const location = useLocation();
  const {
    date = "",
    name = "",
    failureMessage = "",
    // Both callers that route here pass it (AvatarScreen's list row and
    // AvatarProcessing's status listener); it names the scan THIS screen is
    // about, which is not necessarily the last one submitted.
    id = "",
  } = location.state || {};

  return (
    <>
      <div
        style={{
          background: "var(--sm-bg, rgba(240, 242, 250, 1))",
        }}
        className="main-grid"
      >
        <div className="avatar-header-wrap">
          <div>
            <h2>
              {" "}
              <ChevronLeftIcon
                onClick={() => navigateTo("/")}
                className="back-icon"
              />
              Avatar Failed
            </h2>
          </div>
          <div>
            {name} • {date}
          </div>
        </div>{" "}
        <div className="avatar-main-wrap">
          <div className="no-scan-data">
            <div className="avatar-icon">
              <svg
                width="110"
                height="126"
                viewBox="0 0 110 126"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_2116_10623"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="110"
                  height="126"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M61.1823 9.68987C61.1823 11.8469 60.3628 14.6643 58.9865 16.9197C57.5339 19.3001 56.0002 20.2404 54.936 20.2404C53.8718 20.2404 52.3381 19.3001 50.8855 16.9197C49.5092 14.6643 48.6897 11.8469 48.6897 9.68987C48.6897 5.4719 51.7211 2.5 54.936 2.5C58.1509 2.5 61.1823 5.4719 61.1823 9.68987ZM54.936 22.7404C59.7664 22.7404 63.6823 15.0414 63.6823 9.68987C63.6823 4.3383 59.7664 0 54.936 0C50.1055 0 46.1897 4.3383 46.1897 9.68987C46.1897 15.0414 50.1055 22.7404 54.936 22.7404ZM109.333 29.3442H0V31.8442H109.333V29.3442ZM31.1443 121.318C33.2441 106.71 35.9846 87.5098 38.2001 71.9615C39.3079 64.1873 40.2844 57.3261 40.984 52.4083L41.8075 46.6183L42.0293 45.058L42.0867 44.6538L42.1013 44.551L42.105 44.5251L42.1059 44.5186L42.1062 44.517C42.1062 44.5166 42.1063 44.5164 40.8687 44.3405C39.6311 44.1647 39.6311 44.1649 39.631 44.1652L39.6308 44.1668L39.6299 44.1734L39.6262 44.1993L39.6116 44.3021L39.5542 44.7062L39.3324 46.2664L38.5089 52.0562C37.8094 56.9738 36.8329 63.8349 35.7251 71.6089C33.5096 87.157 30.7693 106.356 28.6698 120.963C28.3571 123.138 29.6608 124.727 31.3316 125.142C32.9945 125.556 34.8962 124.776 35.6771 122.735L51.4372 81.5362C51.9854 80.1032 53.3607 79.1568 54.895 79.1568C56.4259 79.1568 57.799 80.0991 58.3495 81.5276L73.8787 121.822C74.6739 123.885 76.6111 124.638 78.279 124.21C79.9525 123.781 81.2801 122.181 80.9484 119.986C78.7519 105.451 76.0067 86.497 73.8103 71.1744C72.7122 63.5136 71.7514 56.7614 71.0651 51.9244C70.7219 49.5059 70.4474 47.5663 70.2587 46.2313L70.0421 44.698L69.9861 44.301L69.9719 44.2L69.9683 44.1746L69.9674 44.1682L69.9672 44.1666C69.9671 44.1663 69.9671 44.1661 68.7293 44.3405C67.4916 44.515 67.4916 44.5152 67.4916 44.5155L67.4919 44.5171L67.4928 44.5235L67.4964 44.549L67.5106 44.6501L67.5667 45.0474L67.7833 46.5812C67.9721 47.9166 68.2467 49.8566 68.5899 52.2756C69.2763 57.1135 70.2373 63.8669 71.3356 71.5291C73.5321 86.8527 76.2785 105.815 78.4764 120.36C78.6063 121.219 78.1558 121.661 77.658 121.788C77.1546 121.918 76.5274 121.743 76.2115 120.923L60.6823 80.6286C59.7599 78.2354 57.4597 76.6568 54.895 76.6568C52.3246 76.6568 50.0206 78.2422 49.1022 80.643L33.3421 121.841C33.0259 122.668 32.4079 122.834 31.9346 122.716C31.4691 122.601 31.0201 122.183 31.1443 121.318Z"
                    fill={BRAND_COLORS.success}
                  />
                </mask>
                <g mask="url(#mask0_2116_10623)">
                  <rect width="109" height="125" fill={BRAND_COLORS.error} />
                  <rect
                    width="109"
                    height="125"
                    transform="matrix(1 0 0 -1 0 125)"
                    fill={BRAND_COLORS.error}
                  />
                </g>
              </svg>
            </div>
            <div className="no-recent-avatars h1">Processing failed</div>
            <div className="create p1">
              Your scan couldn't be processed. Please redo your scan
            </div>

            <div className="no-recent-avatars">What happened?</div>
            <div className="create p1">{failureMessage}</div>
          </div>
        </div>
        <div className="avatar-footer-container">
          <button
            onClick={() => {
              // This screen has just told the user their scan could not be
              // processed, and they are pressing Redo. "Submitted" on the form
              // that follows would contradict the sentence they just read.
              //
              // Scoped to THIS scan on purpose. The live marker is written on
              // submit success and may name a different, later submission: a
              // user who submitted scan B successfully and then opened the
              // older failed scan A has been told about A and nothing about B.
              // Passing the id makes that case a no-op, so B keeps its
              // reassurance. An absent id (no router state — a direct load)
              // also falls through to a no-op, which is the safe direction.
              acknowledgeScanSubmitted(id);
              navigateTo("/new-avatar-screen");
            }}
            className="primary-button"
          >
            Redo Scan
          </button>
        </div>
      </div>
    </>
  );
};

export default AvatarFailed;
